import { useAuth } from '../context/AuthContext';

const UserProfile = ({ showRole = true }) => {
    const { user } = useAuth();

    const getInitials = () => {
        if (user?.firstName && user?.lastName) {
            return `${user.firstName[0]}${user.lastName[0]}`.toUpperCase();
        }
        if (user?.email) {
            return user.email[0].toUpperCase();
        }
        return 'U';
    };

   
    const getUserName = () => {
        if (user?.firstName && user?.lastName) {
            return `${user.firstName} ${user.lastName}`;
        }
        if (user?.email) {
            return user.email;
        }
        return 'User';
    };

    
    const getUserRole = () => {
        if (user?.role) {
            return user.role.charAt(0).toUpperCase() + user.role.slice(1).toLowerCase();
        }
        return 'User';
    };

    return (
        <div className="hidden sm:flex items-center gap-2 bg-white text-primary px-3 py-2 rounded-xl shadow-sm">
            <div className="w-8 h-8 bg-gradient-to-br from-gray-600 to-gray-800 text-white rounded-full flex items-center justify-center font-semibold text-sm">
                {getInitials()}
            </div>
            <div className="text-left">
                {showRole && (
                    <div className="text-[10px] text-gray-600 leading-tight">{getUserRole()}</div>
                )}
                <div className="text-xs font-semibold leading-tight">
                    {getUserName()}
                </div>
            </div>
        </div>
    );
};

export default UserProfile;









